import { Dropdown, Menu } from 'antd';
import { AppModal } from 'shared/UI/UIKit/Modal';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { EducationClassForm } from 'entities/education-class';
import { useCreateEducationClass } from '../model';
import styles from './styles.module.scss';

export const CreateEducationClass = () => {
  const {
    state: { form, isLoading, visible, creationMode },
    methods: { showModal, onSubmit, hideModal },
  } = useCreateEducationClass();

  const footer = (
    <AppFlex direction="row">
      <AppButton onClick={onSubmit}>Создать</AppButton>
      <AppButton type="outline" onClick={hideModal}>
        Отмена
      </AppButton>
    </AppFlex>
  );

  return (
    <>
      <Dropdown
        overlayClassName={styles.dropdown}
        trigger={['click']}
        overlay={
          <Menu>
            <Menu.Item key="create-class" onClick={() => showModal('single')}>
              Создать класс
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item key="create-multiple-classes" onClick={() => showModal('multiple')}>
              Создать классы
            </Menu.Item>
          </Menu>
        }
      >
        <AppButton>Создать</AppButton>
      </Dropdown>

      <AppModal
        visible={visible}
        maskClosable={false}
        onCancel={hideModal}
        content={<EducationClassForm form={form} creationMode={creationMode} />}
        destroyOnClose
        footer={footer}
        loading={isLoading}
        title={creationMode === 'single' ? 'Создать класс' : 'Создать классы'}
      />
    </>
  );
};
